import { Routes, Route } from "react-router-dom";
import About from "./components/About/About";
import Home from "./components/Home/Home";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import MyProjects from "./components/MyProjects/MyProjects";
import ContactMe from "./components/ContactMe/ContactMe";
import Accomplishments from "./components/Accomplishments/Accomplishments";
import { createContext, useState } from "react";
import NotFound from "./components/Shared/NotFound/NotFound";
import 'animate.css';

export const THEME_CONTEXT = createContext();

function App() {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") === "dark" ? true : false || (!localStorage.getItem("theme") && true)
  );

  return (
    <>
      <THEME_CONTEXT.Provider value={{ darkMode, setDarkMode }}>
        <div className={`${darkMode === true ? "dark" : "light"}`}>
          <div className="bg-light-white dark:bg-dark-blue">
            <Routes>
              <Route path="/" element={<Home></Home>}></Route>
              <Route path="/about" element={<About></About>}></Route>
              <Route
                path="/my-projects"
                element={<MyProjects></MyProjects>}
              ></Route>
              <Route
                path="/accomplishments"
                element={<Accomplishments></Accomplishments>}
              ></Route>
              <Route path="/contact" element={<ContactMe></ContactMe>}></Route>
              <Route path="*" element={<NotFound></NotFound>}></Route>
            </Routes>
          </div>
        </div>
      </THEME_CONTEXT.Provider>
    </>
  );
}

export default App;

// C0D8C0
// E4EFE7

// Color:
// --> OwnBranding
//     bg: #0A192F=dark    #f5f5f5=light
//     limeColor: #04BF00

// --> brittanychiang
//     bg: #0A192F
